import React, { useEffect, memo } from 'react';
import { connect } from 'react-redux';
import {
  selectCurrentDisplayedIncident,
  selectIncidentSkillAssignments
} from '../../../../state/modules/incidents/selectors';
import { Grid, Row, Col, ListGroup } from '../../../ui-kit';
import WaitingForIncidentMessage from '../shared/IncidentWidgets/WaitingForIncidentMessage';
import SkillIconList from '../../../general/SkillIconList';
import Loader from '../../../general/Loader';
import './IncidentSkillAssignments.scss';
import SettingsForm from '../ui-kit/SettingsForm';

const Settings = ({ updateWidgetSettingsField, widgetSettings }) => (
  <SettingsForm
    updateWidgetSettingsField={updateWidgetSettingsField}
    widgetSettings={widgetSettings}
    withAutoResizeHeight={true}
    withAutoScroll={true}
  />
);

// Defines the color of the list item
const statusToVariant = {
  acknowledged: 'success',
  pending: null,
  rejected: 'danger'
};

const AssignmentItem = ({ assignment }) => {
  const { name, status, skills } = assignment;
  const variant = statusToVariant[status];

  return (
    <ListGroup.Item variant={variant}>
      <Grid>
        <Row className="assigment-row">
          <Col md={3} className="skill-column">
            <h3 className="m-0">
              <SkillIconList skills={skills} />
            </h3>
          </Col>
          <Col md={9} className="name-column">
            <h3 className="m-0">{name}</h3>
          </Col>
        </Row>
      </Grid>
    </ListGroup.Item>
  );
};

// to test
//
// group = Group.find(44)
// incident = FactoryBot.create(:incident, tasks: [group.tasks.first])
// membership = group.memberships.first
// response = FactoryBot.create(:incident_response, incident:, membership:)
// skills = [Group.find(44).skills.first]
// response = incident.incident_skill_assignments.create(membership:, skills:)
// response.acknowledge!
//
const IncidentSkillAssignments = ({ incidentSkillAssignments, displayedIncident, skills, dashboardAPIManager }) => {
  useEffect(() => {
    dashboardAPIManager.fetchSkills();
  }, []);

  if (!skills.lastFetch) return <Loader />;
  if (!displayedIncident) return <WaitingForIncidentMessage />;

  return (
    <ListGroup>
      {incidentSkillAssignments.length === 0 && (
        <ListGroup.Item>
          <i>{I18n.t('no_results_found')}</i>
        </ListGroup.Item>
      )}
      {incidentSkillAssignments.map(assignment => (
        <AssignmentItem key={assignment.id} assignment={assignment} />
      ))}
    </ListGroup>
  );
};

const mapStateToProps = state => ({
  skills: state.skills,
  displayedIncident: selectCurrentDisplayedIncident(state),
  incidentSkillAssignments: selectIncidentSkillAssignments(state)
});

const ConnectedIncidentSkillAssignments = connect(mapStateToProps)(memo(IncidentSkillAssignments));

Object.assign(ConnectedIncidentSkillAssignments, {
  SettingsContent: Settings,
  defaultSettings: { defaultAutoScrollEnabled: true }
});

export default ConnectedIncidentSkillAssignments;
